import { tryParseString } from 'features/Integrations/utils/parser.utils';

// Default coordinate fallback for devices with missing/invalid values.
const DEFAULT_COORDS = { lat: 0.0, lng: 0.0 };

// Parse coordinates/location strings and guard against invalid objects.
const normalizeCoordsValue = (value) => {
  const parsed = tryParseString(value);
  if (!parsed || typeof parsed !== 'object') return null;
  return parsed;
};

// Ensure devices always have valid coordinates/location objects.
export const normalizeDevice = (device) => {
  if (!device || typeof device !== 'object') return device;
  return {
    ...device,
    coordinates: normalizeCoordsValue(device.coordinates),
    location: normalizeCoordsValue(device.location),
  };
};

// Normalize a collection of devices in one pass.
export const normalizeConnectedDevices = (devices = []) =>
  devices.map((device) => normalizeDevice(device));

// Normalize group shape to include a merged `devices` array.
// Handles both old field names (auxDevices, coordinates, iconId) and new (aux_devices, coords, icon_id).
export const normalizeGroup = (group) => {
  if (!group || typeof group !== 'object') return group;
  const aux_devices = group.aux_devices ?? group.auxDevices ?? [];
  const coords = group.coords ?? group.coordinates ?? [];
  const icon_id = group.icon_id ?? group.iconId ?? 0;
  // Pull out old keys to avoid confusion, but keep any other keys.
  const {
    auxDevices,
    coordinates,
    iconId,
    aux_devices: _a,
    coords: _c,
    icon_id: _i,
    ...rest
  } = group;
  return {
    ...rest,
    aux_devices,
    coords,
    icon_id,
    devices: [...(group.controllers || []), ...(group.devices || []), ...aux_devices],
  };
};

// Normalize a collection of groups in one pass.
export const normalizeGroups = (groups = []) => groups.map((group) => normalizeGroup(group));
